import axios from "axios";
import { environment } from './environment'
import { saveAs } from 'file-saver';
const endpoint = environment.serverUrl;


  export async function downloadMenuBulkResult(storeUrl,bulkId,type) {
    try {
      const response = await axios.get(endpoint+"/api/Menu/download-bulk-result?storeUrl=" +storeUrl + "&bulkId="+bulkId +"&type=" + type, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "text/plain" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "result-"+storeUrl+"-"+type+".csv");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
        console.error(error);
    }
  };

  export async function menuBulkCancel(storeUrl,bulkId) {
    return await axios
        .post(endpoint+"/api/Menu/bulk-cancel?storeUrl=" +storeUrl + "&bulkId="+bulkId)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}

export async function MenuBulkPolling(storeUrl) {
    return await axios
        .get(endpoint + '/api/Menu/bulk-polling?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function DeleteMenuLogs(storeUrl) {
    return await axios
        .delete(endpoint+'/api/Menu/delete-older-logs?storeUrl=' +storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })   
}

export async function getMenuImportHistory(storeUrl,pageNo, pageSize) {
    return await axios
        .get(endpoint + '/api/Menu/import-logs?storeUrl='+ storeUrl + '&pageNo='+pageNo + '&pageSize='+pageSize)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function menuExportStatus(storeUrl) {
    return await axios
        .get(endpoint + '/api/Menu/export-status?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}
